import React, { useState, useEffect } from "react";
import { useAuth } from "../contexts/AuthContext";
import { api } from "../lib/api";
import { useI18n } from "../contexts/I18nContext";

export default function AccountModal({ isOpen, onClose, requireSetup = false }) {
  const { user, checkAuth } = useAuth();
  const { t } = useI18n();
  const [name, setName] = useState("");
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (user?.name && user.name !== "User") {
      setName(user.name);
    }
  }, [user]);

  if (!isOpen) return null;

  const handleSave = async (e) => {
    e.preventDefault();
    if (!name.trim()) {
      setError(t("name_empty_error"));
      return;
    }
    setError("");
    setSaving(true);
    try {
      await api.patch("/auth/me", { name: name.trim() });
      await checkAuth(); // refresh user context
      onClose();
    } catch (err) {
      setError(t("name_save_error"));
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center bg-black/60 backdrop-blur-sm p-4">
      <div className="bg-white rounded-3xl w-full max-w-sm overflow-hidden shadow-2xl animate-in fade-in zoom-in-95 duration-200">
        <div className="p-6">
          <h2 className="text-xl font-display text-[#02371b] mb-2">
            {requireSetup ? t("welcome_title") : t("account_settings")}
          </h2>
          <p className="text-sm text-neutral-500 mb-6">
            {requireSetup
              ? t("welcome_desc")
              : t("update_name_desc")}
          </p>

          <form onSubmit={handleSave}>
            <div className="mb-5">
              <label className="block text-xs font-bold text-neutral-700 uppercase tracking-wider mb-2">
                {t("display_name")}
              </label>
              <input
                type="text"
                maxLength={50}
                value={name}
                onChange={(e) => setName(e.target.value)}
                placeholder={t("name_placeholder")}
                className="w-full bg-neutral-50 border border-neutral-200 rounded-xl px-4 py-3 text-[#02371b] focus:outline-none focus:ring-2 focus:ring-[#41a42b]/50 transition-shadow"
                autoFocus
              />
              {error && <p className="text-red-500 text-xs mt-2">{error}</p>}
            </div>

            <div className="flex gap-3">
              {!requireSetup && (
                <button
                  type="button"
                  onClick={onClose}
                  className="flex-1 px-4 py-3 rounded-xl font-bold text-neutral-600 bg-neutral-100 hover:bg-neutral-200 transition-colors"
                >
                  {t("cancel")}
                </button>
              )}
              <button
                type="submit"
                disabled={saving || !name.trim()}
                className="flex-1 px-4 py-3 rounded-xl font-bold text-white bg-[#41a42b] hover:bg-[#368a23] transition-colors disabled:opacity-50 flex items-center justify-center"
              >
                {saving ? (
                  <div className="w-5 h-5 border-2 border-white/30 border-t-white rounded-full animate-spin" />
                ) : requireSetup ? (
                  t("lets_go")
                ) : (
                  t("save")
                )}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}
